<template>
  <div v-loading="loading" style="padding: 20px">
    <div v-if="itemList && itemList.length > 0">
      <template v-for="(item, i) in itemList">
        <div class="order-item">
          <goods-sku-info :skuInfo="item.skuInfo">
            <template slot="info-append">
              <div v-if="item.purchasePrice > 0" style="color: #919191; font-size: 14px">
                <span> 采购单价: </span>
                <span style="color: #333333; font-weight: bolder">
                  {{ item.purchasePrice }}
                </span>
                <span> 元/件 </span>
              </div>
              <div style="color: #919191; font-size: 14px">
                <span> 采购数量: </span>
                <span style="color: #333333; font-weight: bolder">
                  {{ item.purchaseCount }}
                </span>
                <span> 份商品 </span>
              </div>
              <div style="color: #919191; font-size: 14px">
                <span> 小计金额: </span>
                <span style="color: #333333; font-weight: bolder">
                  {{ item.purchaseAmount }}
                </span>
                <span> 元 </span>
              </div>
              <div style="margin-top: 5px">
                <div
                  :style="
                    item.inboundAvailable > 0
                      ? 'color: #3399ff'
                      : item.inboundCount > 0
                      ? 'color: #67C23A'
                      : 'color: #919191'
                  "
                >
                  <span> 入库: </span>
                  <span> {{ item.inboundCount }}/{{ item.purchaseCount }} </span>
                </div>
              </div>
            </template>
          </goods-sku-info>
          <div>
            <div v-if="item.optRemark">
              <div class="wordwrap">
                备注:
                <span class="item-remark">{{ item.optRemark }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="fetchList" size="small"> 重新加载 </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.item-count {
  padding: 5px 10px;
  background-color: #f1f1f1;
  margin-bottom: 20px;
  color: #444444;

  .status-label {
    margin-right: 5px;
    font-weight: bolder;
    color: #000000;
  }

  .count-label {
    color: #000000;
    float: right;
  }
}

.order-item {
  margin-top: 10px;
  margin-bottom: 20px;
  .item-remark {
    font-weight: bolder;
    color: #e87431;
  }
}
</style>

<script>
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";

export default {
  components: {
    goodsSkuInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    inInternal() {
      return this.tabName == "order-itemlist";
    },
    defaultParams() {
      return {
        storeGuid: this.pageParams.storeGuid,
        purchaseGuid: this.pageParams.guid,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      itemList: null,
    };
  },
  methods: {
    fetchList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      return this.requestApi("biz.warehouse.purchase.item.list", this.defaultParams)
        .then((resp) => {
          this.loading = false;
          this.itemList = resp.data.list || [];
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        });
    },
  },
  mounted() {
    this.fetchList();
  },
};
</script>
